var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { styled, css } from '@creditas-ui/system';
import { ifProp, selectTheme, mixins } from '@creditas-ui/utilities';
import { Flex } from '@creditas-ui/layout';

var selectedValue = _ref => {
  var {
    theme: {
      dropdown
    }
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  top: ", ";\n  display: block;\n"])), dropdown('placeholder.selected.fontSize'), dropdown('placeholder.selected.top'));
};

var disabled = _ref2 => {
  var {
    theme: {
      dropdown
    }
  } = _ref2;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), dropdown('disabled.color'));
};

var itemSelected = _ref3 => {
  var {
    theme: {
      dropdown
    }
  } = _ref3;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), dropdown('options.item.selected.color'));
};

var optionItemDisabled = _ref4 => {
  var {
    theme: {
      dropdown
    }
  } = _ref4;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  cursor: initial;\n"])), dropdown('disabled.color'));
};

var arrowDisabled = _ref5 => {
  var {
    theme: {
      dropdown
    }
  } = _ref5;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  stroke: ", ";\n"])), dropdown('disabled.color'));
};

var optionsMenuVisible = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: block;\n"])));
var Icon = styled.svg(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: ", ";\n  top: 22px;\n"])), selectTheme('dropdown.shape.icon.right'));
var Container = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"])));
var Select = styled(Flex)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  min-width: max-content;\n  cursor: pointer;\n  font-weight: 400;\n  position: relative;\n  line-height: 1;\n  border-style: none;\n  font-family: ", ";\n  border-radius: ", ";\n  height: ", ";\n  padding: ", ";\n  color: ", ";\n  background-color: ", ";\n  &:focus {\n    outline: none;\n  }\n"])), selectTheme('dropdown.shape.fontFamily'), selectTheme('dropdown.shape.borderRadius'), selectTheme('dropdown.shape.height'), selectTheme('dropdown.shape.padding'), selectTheme('dropdown.shape.color'), selectTheme('dropdown.shape.backgroundColor'));
var Placeholder = styled.label(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  left: ", ";\n  top: ", ";\n  position: absolute;\n  transition: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: calc(100% - 70px);\n  ", ";\n  ", ";\n  color: ", ";\n"])), selectTheme('dropdown.placeholder.fontSize'), selectTheme('dropdown.placeholder.left'), selectTheme('dropdown.placeholder.top'), selectTheme('dropdown.placeholder.transition'), ifProp({
  hasSelectedValue: true
}, selectedValue), ifProp({
  isDisabled: true
}, disabled), ifProp({
  error: true
}, selectTheme('dropdown.placeholder.error.color')));
var Options = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: none;\n  position: absolute;\n  width: 100%;\n  max-height: 250px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  z-index: 2;\n  top: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  background: ", ";\n  ", ";\n  ", ";\n"])), selectTheme('dropdown.options.top'), selectTheme('dropdown.options.boxShadow'), selectTheme('dropdown.options.borderRadius'), selectTheme('dropdown.options.backgroundColor'), ifProp({
  isVisible: true
}, optionsMenuVisible), mixins.scrollBar);
var OptionItem = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  font-family: ", ";\n  padding: ", ";\n  font-size: ", ";\n  color: ", ";\n  ", ";\n  ", ";\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:first-of-type {\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n  }\n\n  &:last-child {\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n  }\n"])), selectTheme('dropdown.options.item.fontFamily'), selectTheme('dropdown.options.item.padding'), selectTheme('dropdown.options.item.fontSize'), selectTheme('dropdown.options.item.color'), ifProp({
  isSelected: true
}, itemSelected), ifProp({
  isDisabled: true
}, optionItemDisabled), selectTheme('dropdown.options.item.hover.backgroundColor'), selectTheme('dropdown.options.item.first.borderRadius'), selectTheme('dropdown.options.item.first.borderRadius'), selectTheme('dropdown.options.item.last.borderRadius'), selectTheme('dropdown.options.item.last.borderRadius'));
var SelectedValue = styled.p(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  text-align: left;\n  margin: 0;\n  color: ", ";\n  font-size: ", ";\n  ", ";\n  display: ", ";\n  position: absolute;\n  top: ", ";\n"])), selectTheme('dropdown.selectedValue.fontFamily'), selectTheme('dropdown.selectedValue.color'), selectTheme('dropdown.selectedValue.fontSize'), ifProp({
  isDisabled: true
}, disabled), ifProp({
  isVisible: true
}, 'block', 'none'), selectTheme('dropdown.selectedValue.top'));
var DummyInput = styled.input(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  text-align: left;\n  margin: 0;\n  border: none;\n  background: inherit;\n  outline: inherit;\n  padding: 0;\n  color: ", ";\n  font-size: ", ";\n  display: ", ";\n"])), selectTheme('dropdown.selectedValue.fontFamily'), selectTheme('dropdown.selectedValue.color'), selectTheme('dropdown.selectedValue.fontSize'), ifProp({
  isVisible: true
}, 'block', 'none'));
var Path = styled.path(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  stroke: ", ";\n  ", ";\n"])), selectTheme('dropdown.shape.arrow.color'), ifProp({
  isDisabled: true
}, arrowDisabled));
export { Select, Placeholder, Options, OptionItem, Container, SelectedValue, Icon, Path, DummyInput };
//# sourceMappingURL=Dropdown.style.js.map